import { GetServerSideProps } from 'next';
import Layout from 'components/home/Layout';
import SignUpForm from '../components/forms/SignUpForm';
import { getTeamName } from 'services/team';
import SEO from 'components/home/SEO';

const SignUpPage: React.FC<{
  teamId?: string;
  teamName?: string;
  email?: string;
}> = ({ teamId, teamName, email }) => {
  return (
    <>
      <SEO prefix="Sign up" />
      <Layout>
        <div className="flex flex-col min-h-screen bg-gray-50">
          <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
            <div className="mt-24 text-center">
              {teamName ? (
                <>
                  <h2 className="mt-6 text-3xl font-extrabold leading-9 text-center text-gray-900">
                    You were invited to a team!
                  </h2>
                  <p className="mt-2 mx-auto text-center text-gray-600 text-md">
                    {`Sign up to join ${teamName}`}
                  </p>
                </>
              ) : (
                <>
                  <h2 className="mt-6 text-3xl font-extrabold leading-9 text-center text-gray-900">
                    Sign up for free!
                  </h2>
                  <p className="mt-2 mx-auto text-center text-gray-600 text-md">
                    Start creating performance test reports today
                  </p>
                </>
              )}
            </div>
            <div className="px-4 py-8 mt-8 bg-white shadow-lg sm:rounded-lg sm:px-10">
              <SignUpForm teamId={teamId} email={email} showLogin={!teamName} />
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { teamId, email } = context.query;
  let teamName;

  if (!teamId) {
    return { props: {} };
  }

  if (teamId) {
    teamName = await getTeamName(teamId as string);
  }

  return {
    props: { teamId, teamName, email: email || '' },
  };
};

export default SignUpPage;
